import React from 'react';
import styles from './HelpForm.module.css';
import { Alert, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from 'reactstrap';
import { Formik } from 'formik';
import LoadingOverlay from '../../general/LoadingOverlay';
import * as Yup from 'yup';
import * as Constants from '../../Constants';
import { Col, Row } from 'reactstrap';
import getFileAsBase64 from '../../general/FileReader';
import PrivacyPolicy from './PrivacyPolicy';

export default class WantHelpForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            response: false,
            isLoading: false,
            isPpOpen: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    submit = async (values) => {
        //console.log(values);
        this.setState({ ...this.state, isLoading: true })
        let serializableValues = { ...values, type: Constants.TYPEDONOR };
        if (values.file) {
            serializableValues.file = await getFileAsBase64(values.file);
            //console.log(serializableValues);
        }
        const response = await fetch(Constants.TOBOGAURL + '/nadace/submitDonationConfirmation', {
            method: 'post',
            body: JSON.stringify(serializableValues),
            headers: { 'Content-Type': 'application/json' }
        });
        response.json().then((json) => {
            this.setState({ ...this.state, response: json });
        });
    }

    handlePpToggle = () => {
        this.setState({ ...this.state, isPpOpen: !this.state.isPpOpen });
    }

    handleSuccess = () => {
        this.setState({ ...this.state, isLoading: false });
    }

    toggle = () => {
        this.setState({ ...this.state, isLoading: false, modal: !this.state.modal, response: false });
    }

    render() {
        return (
            <>
                <a href="#" onClick={this.toggle}>{this.props.linkText}</a>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                    <ModalHeader toggle={this.toggle}>Žádost o potvrzení o daru</ModalHeader>
                    <ModalBody>
                        {this.state.response && this.state.response.success ? this.renderSuccess() : this.renderForm()}
                    </ModalBody>
                </Modal>
            </>
        );
    }

    renderError() {
        return (
            <div>
                <Alert color="danger">{this.state.response.message}</Alert>
            </div>
        );
    }

    renderSuccess() {
        return (
            <div>
                <Alert color="success">Děkujeme, potvrzení o daru vyhotovíme co nejdříve</Alert>
                <div className="text-right">
                    <Button className={'gradient-bg'} onClick={this.toggle}>Ok</Button>
                </div>
            </div>
        );
    }

    renderForm() {
        return (
            <div>
                <p>
                    Vyplňte prosím údaje k již uskutečněnému daru, abychom vám mohli vystavit potvrzení.
                </p>
                <LoadingOverlay active={this.state.isLoading} spinner>
                    {this.state.response && !this.state.response.success && this.renderError()}
                    <Formik
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            this.submit(values).finally(() => {
                                setSubmitting(false);
                                if (this.props.response && this.props.response.success) {
                                    resetForm();
                                }
                                this.handleSuccess();
                            });
                        }}
                        initialValues={{
                            donorType: 'person',
                            amount: '',
                            donationDate: '',
                            name: '',
                            ico: '',
                            email: '',
                            address: '',
                            paymentNote: '',
                            isvoluntary: false,
                            ppconfirm: false,
                            ispublic: false,
                        }}
                        validationSchema={Yup.object().shape({
                            donorType: Yup.string().required(),
                            amount: Yup.number()
                                .typeError('Zadejte částku')
                                .positive('Částka musí být kladná')
                                .required('Povinné pole'),
                            donationDate: Yup.date()
                                .required('Povinné pole'),
                            name: Yup.string()
                                .required('Povinné pole'),
                            ico: Yup.string().when('donorType', {
                                is: 'company',
                                then: schema => schema.required('Povinné pole'),
                                otherwise: schema => schema.notRequired(),
                            }),
                            email: Yup.string()
                                .required('Povinné pole')
                                .email('Není validní email'),
                            address: Yup.string()
                                .required('Povinné pole'),
                            paymentNote: Yup.string(),
                            isvoluntary: Yup.bool()
                                .oneOf([true], 'Povinné pole'),
                            ppconfirm: Yup.bool()
                                .oneOf([true], 'Povinné pole'),
                            ispublic: Yup.bool(),
                        })}
                    >
                        {props => {
                            const {
                                touched,
                                errors,
                                isSubmitting,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                values,
                            } = props;

                            return (
                                <Form onSubmit={handleSubmit}>
                                    <fieldset className="border p-3 mb-2">
                                        <legend className="w-auto">Údaje o daru</legend>
                                        <FormGroup>
                                            <Row>
                                                <Col lg="6">
                                                    {errors.amount && touched.amount && <div className={styles.validationerror}>{errors.amount}</div>}
                                                    <Label for="amount">Částka daru (Kč)</Label>
                                                    <Input type="number" name="amount" onChange={handleChange} onBlur={handleBlur} />
                                                </Col>
                                                <Col lg="6">
                                                    {errors.donationDate && touched.donationDate && <div className={styles.validationerror}>{errors.donationDate}</div>}
                                                    <Label for="donationDate">Datum odeslání daru</Label>
                                                    <Input type="date" name="donationDate" onChange={handleChange} onBlur={handleBlur} />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="paymentNote">Zpráva pro příjemce / variabilní symbol</Label>
                                            <Input type="text" name="paymentNote" onChange={handleChange} onBlur={handleBlur} />
                                        </FormGroup>
                                    </fieldset>

                                    <fieldset className="border p-3 mb-2">
                                        <legend className="w-auto">Údaje o dárci</legend>
                                        <FormGroup>
                                            <Label for="donorType">Typ dárce</Label>
                                            <Input type="select" name="donorType" value={values.donorType} onChange={handleChange}>
                                                <option value="person">Fyzická osoba</option>
                                                <option value="company">Právnická osoba</option>
                                            </Input>
                                        </FormGroup>
                                        <FormGroup>
                                            {errors.name && touched.name && <div className={styles.validationerror}>{errors.name}</div>}
                                            <Label for="name">
                                                {values.donorType === 'company' ? 'Název společnosti' : 'Jméno a příjmení'}
                                            </Label>
                                            <Input type="text" name="name" onChange={handleChange} onBlur={handleBlur} />
                                        </FormGroup>
                                        {values.donorType === 'company' && (
                                            <FormGroup>
                                                {errors.ico && touched.ico && <div className={styles.validationerror}>{errors.ico}</div>}
                                                <Label for="ico">IČO</Label>
                                                <Input type="text" name="ico" onChange={handleChange} onBlur={handleBlur} />
                                            </FormGroup>
                                        )}
                                        
                                        <FormGroup>
                                            {errors.email && touched.email && <div className={styles.validationerror}>{errors.email}</div>}
                                            <Label for="email">E-mail (kam zaslat potvrzení)</Label>
                                            <Input type="email" name="email" onChange={handleChange} onBlur={handleBlur} />
                                        </FormGroup>
                                        <FormGroup>
                                            {errors.address && touched.address && <div className={styles.validationerror}>{errors.address}</div>}
                                            <Label for="address">Adresa</Label>
                                            <Input type="textarea" name="address" onChange={handleChange} onBlur={handleBlur} />
                                        </FormGroup>
                                    </fieldset>

                                    <FormGroup>
                                        <Label className={styles.checkbox}>
                                            <Input type="checkbox" name="isvoluntary" onChange={handleChange} />
                                            {errors.isvoluntary && touched.isvoluntary && <div className={styles.validationerror}>{errors.isvoluntary}</div>}
                                            Prohlašuji, že jsem uvedený dar poskytl(a) dobrovolně a uvedené údaje jsou pravdivé
                                        </Label>

                                        <Label className={styles.checkbox}>
                                            <Input type="checkbox" name="ispublic" onChange={handleChange} />
                                            Chci být uveden(a) na seznamu dárců
                                        </Label>

                                        <Label className={styles.checkbox}>
                                            {errors.ppconfirm && touched.ppconfirm && <div className={styles.validationerror}>{errors.ppconfirm}</div>}
                                            <Input type="checkbox" name="ppconfirm" onChange={handleChange} />
                                            Souhlasím se zpracováním <span className={styles.link} onClick={this.handlePpToggle}>osobních údajů</span>
                                            <PrivacyPolicy isOpen={this.state.isPpOpen} toggle={this.handlePpToggle} />
                                        </Label>
                                    </FormGroup>

                                    <div className="text-right">
                                        <Button className="gradient-bg" type="submit" disabled={isSubmitting}>
                                            Odeslat žádost o potvrzení
                                        </Button>
                                    </div>

                                </Form>
                            );
                        }}
                    </Formik>
                </LoadingOverlay>
            </div>
        );
    }
}